module.exports = __webpack_public_path__ + "static/media/banner.f51c1e48.jpg";